import React from 'react';
import { useDroppable } from '@dnd-kit/core';

import './OfficeViewDropZone.scss';

const OfficeViewDropZone = ({ content, currentCallUUID, isCompressed, compressionSize }) => {
    const { isOver, setNodeRef, active: call } = useDroppable({
        id: 'office-view-call-box',
        data: {
            type: 'call-destination'
        }
    });

    const shouldShowDropzone = isOver && call.id !== currentCallUUID;
    const className = 'OfficeView__drop-zone';
    const modifiers = [
        shouldShowDropzone && `dragging-over`,
        isCompressed && `compressed${compressionSize ? `-${compressionSize}` : ''}`
    ].filter(Boolean).map(modifier => `${className}--${modifier}`).join(' ');
    return (
        <div className={`OfficeView__drop-zone ${modifiers}`} ref={setNodeRef}>
            {!shouldShowDropzone && content}
        </div>
    )
}

export default OfficeViewDropZone;
